import {combineReducers} from "redux";
import uiReducer from "./uiReducer";
const affiliateMemberReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_AFFILIATE_MEMBER":
      return {...state, [action.payload.name]: action.payload.value};
    default:
      return state;
  }
}

const affiliateMemberDetailReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_AFFILIATE_MEMBER_DETAIL":
      return {...state, [action.payload.name]: action.payload.value};
    default:
      return state;
  }
}

const affiliateMemberAddressReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_AFFILIATE_MEMBER_ADDRESS":
      return {...state, [action.payload.name]: action.payload.value};
    default:
      return state;
  }
}

export default combineReducers({
  affiliateMember: affiliateMemberReducer,
  affiliateMemberDetail: affiliateMemberDetailReducer,
  affiliateMemberAddress: affiliateMemberAddressReducer,
  stateOptions: (state = {}) => state,
  organization: (state = {}) => state,
  currentUser: (state = {}) => state,
  ui: uiReducer,
});
